import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface TillageCellDisplayProps {
  value: any
}

export const TillageCellDisplay = ({ value }: TillageCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager')

  if (value?.source === 'cibo') {
    return (
      <Stack>
        <Typography
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {t(value?.result)}
        </Typography>
      </Stack>
    )
  } else {
    return (
      <Typography
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {t(`tillage_${value?.result}`)}
      </Typography>
    )
  }
}
